import React, {Component, ReactElement} from 'react'
import NatStepComponent, {DIspStepInfo, Step} from '../common/resident/NatStepComponent'
import {
    ContentsSubTitleInner,
    ContentsSubTitleWrapper,
    WideMainContainer,
} from '../../../styledComponents/ContentsArea'
import {CenterPlainLinkStyledButton, PrimaryStyledButton} from '../../../styledComponents/Button'
import {createResidentPage, ResidentPagePropsSet} from '../../../components/shared/hoc/createResidentPage'
import {Nullable} from '../../../app/TypeHelpers'
import {Box} from '@mui/material'
import {RECEIVING_AGENCY_CD} from '../../../CodeMaster'
import {BlockSpacer} from '../../../styledComponents/ResponsiveConvenience'
import {Location} from 'react-router-dom'


interface FirstLoginLocationState {
    dIspStepInfo: DIspStepInfo
    condominiumCd: string
    receivingAgencyCd: string,
    isOwnershipTransfer: boolean
}

interface Props {
    location: Location<FirstLoginLocationState>
}

interface States {
    isLoadCompleted: boolean
}

class NatResidentFirstLoginUserInfoCompletePage extends Component<Props & ResidentPagePropsSet, States> {
    constructor(props: Props & ResidentPagePropsSet) {
        super(props)

        this.state = {
            isLoadCompleted: false,
        }

        if (!this.props.location.state) {
            window.location.href = `/resident/error`
            return
        }

        this.loginButtonClick = this.loginButtonClick.bind(this)
        this.accountTransferButtonClick = this.accountTransferButtonClick.bind(this)
    }

    componentDidMount(): void {
        this.setState({isLoadCompleted: true})
    }

    // ログインページへ
    loginButtonClick(): void {
        this.props.navigate(
            `/resident/login`,
        )
    }

    // 口座振替登録へ
    accountTransferButtonClick(): void {
        const {condominiumCd, receivingAgencyCd} = this.props.location.state
        this.props.navigate(
            `/resident/login?seniurl=/resident/condominiums/${condominiumCd}/applications/account-transfer/${receivingAgencyCd}`,
        )
    }

    render(): Nullable<ReactElement> {
        if (!this.state.isLoadCompleted) {
            return null
        }

        const {dIspStepInfo, receivingAgencyCd, isOwnershipTransfer} = this.props.location.state
        const isAccountTransfer = (receivingAgencyCd === RECEIVING_AGENCY_CD.RESONA_KS.value
            || receivingAgencyCd === RECEIVING_AGENCY_CD.SMBC_CARD.value) && isOwnershipTransfer

        return (
            <>
                <NatStepComponent
                    dIspStepInfo={dIspStepInfo}
                    nowStep={Step.COMPLETE}
                />
                <ContentsSubTitleWrapper>
                    <ContentsSubTitleInner>
                        ユーザ情報登録完了
                    </ContentsSubTitleInner>
                </ContentsSubTitleWrapper>
                <WideMainContainer>
                    <Box height={'15px'}/>
                    登録が完了しました。<br/>
                    メールアドレスに登録完了メールを送信しました。
                    <Box height={'15px'}/>
                    2回目以降は登録いただいたメールアドレスとパスワードにて、ログインいただけますようお願い致します。
                    <Box height={'15px'}/>
                    サブユーザ登録希望の方は、メインユーザにてログインし、サブユーザ登録をお願い致します。
                    <Box height={'20px'}/>
                    素敵ネットから入居に必要な{isAccountTransfer ? '口座振替登録や' : ''}各種申請手続きをご利用いただけます。
                    <Box height={'20px'}/>
                </WideMainContainer>
                <Box height={'30px'}/>
                {
                    isAccountTransfer ?
                        <>
                            <PrimaryStyledButton onClick={this.accountTransferButtonClick}>
                                口座振替登録へ進む
                            </PrimaryStyledButton>
                            <BlockSpacer height={'30px'}/>
                            <CenterPlainLinkStyledButton onClick={this.loginButtonClick}>
                                ログイン画面へ進む
                            </CenterPlainLinkStyledButton>
                        </> :
                        <PrimaryStyledButton onClick={this.loginButtonClick}>
                            ログイン画面に進む
                        </PrimaryStyledButton>
                }
                <Box height={'30px'}/>
            </>
        )
    }
}

export default createResidentPage(NatResidentFirstLoginUserInfoCompletePage)
